import { useParams, useNavigate, NavLink, Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import userimg from "../../images/userimg.png";
import Brokerinfo from "../../components/Brokerinfo/Brokerinfo";
import Search from "./Search/Search";
import logo from "../../images/MyYerevanLogo.png";
import "./userPage.css";

export default function UserPage({
  managers,
  brokers,
  setAsr,
  estateOn,
  asr,
  my,
  setMy,
  setSearchedData,
  district,
  district1,
  district2,
  setDistrict,
  setDistrict1,
  setDistrict2,
  data,
  allDeleted,
}) {
  const { id } = useParams();
  const brokerinf = brokers.find((el) => String(el.broker_id) === id);
  const managerinf = managers.find((el) => String(el.manager_id) === id);
  const brokerinfo = brokerinf || managerinf;
  const [brokerinfoShow, setBrokerinfoShow] = useState(false);

  const [formData, setFormData] = useState({
    ownPhoneNumber: "",
    workPhoneNumber: "",
    image: userimg,
  });
  const [isSmall, setIsSmall] = useState(window.innerWidth <= 900);
  const navigate = useNavigate();
  
  useEffect(() => {
  const savedToken = localStorage.getItem("authToken");
  const savedId = localStorage.getItem("userId");

  if (!savedToken || savedId !== id) {
    navigate("/");
  }
}, [id, navigate]);

  useEffect(() => {
    if (brokerinfo) {
      setFormData({
        ownPhoneNumber: brokerinfo.phone_number || "",
        workPhoneNumber: brokerinfo.work_number || "",
        image: brokerinfo.image || userimg,
      });
    }
  }, [brokerinfo]);

  if (!brokerinfo) return <p>Loading...</p>;

  const brokerImg = formData.image || userimg;

  return (
    <div className="userPage">
      <div className="brokerinfo">
        <img
          className="clogo"
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (window.location.pathname === `/${id}`) {
              window.location.reload();
            } else {
              navigate(`/${id}`);
            }
          }}
          onDoubleClick={() => {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }}
          src={logo}
          alt=""
        />
        <div className="brokerns">
          <img
            className="brokerimg"
            src={brokerImg}
            alt="Broker"
            onClick={() => setBrokerinfoShow(!brokerinfoShow)}
          />
          <p>
            {brokerinfo.broker_name && brokerinfo.broker_name}{" "}
            {brokerinfo.broker_surname && brokerinfo.broker_surname}
            {brokerinfo.manager_name && brokerinfo.manager_name}{" "}
            {brokerinfo.manager_surname && brokerinfo.manager_surname}
          </p>
          {brokerinfoShow && <Brokerinfo formData={formData} />}
        </div>
      </div>
      <nav>
        {!my && brokerinfo.manager_id !== 6 &&(
          <button
            style={{ cursor: "pointer" }}
            className="goTomyAll"
            onClick={() => setMy(!my)}
          >
            ԻՄ ԳՈՒՅՔԵՐԸ
          </button>
        )}
        {my && brokerinfo.manager_id !== 6 &&(
          <button
            style={{ cursor: "pointer" }}
            className="goTomyAll"
            onClick={() => setMy(!my)}
          >
            ԲՈԼՈՐ ԳՈՒՅՔԵՐԸ
          </button>
        )}

	{!my && brokerinfo.manager_id === 6 &&(
          <button
            style={{ cursor: "pointer" }}
            className="goTomyAll"
            onClick={() => setMy(!my)}
          >
            ԲՈԼՈՐ ԳՈՒՅՔԵՐԸ
          </button>
        )}
        {my && brokerinfo.manager_id === 6 && (
          <button
            style={{ cursor: "pointer" }}
            className="goTomyAll"
            onClick={() => setMy(!my)}
          >
            ԻՄ ԳՈՒՅՔԵՐԸ
          </button>
        )}  

        <NavLink
          
          className={({ isActive }) => (isActive ? "active" : "")}
          onClick={() => setAsr([true, false, false, false])}
          to="all"
        >
          ԲՈԼՈՐԸ
        </NavLink>
        <NavLink
	  end
          className={({ isActive }) => (isActive ? "active" : "")}
          onClick={() => setAsr([false, true, false, false])}
          to=""
        >
          ՎԱՃԱՌՔ
        </NavLink>
        <NavLink
          className={({ isActive }) => (isActive ? "active" : "")}
          onClick={() => setAsr([false, false, true, false])}
          to="rent"
        >
          ՎԱՐՁ
        </NavLink>
        <NavLink
          className={({ isActive }) => (isActive ? "active" : "")}
          onClick={() => setAsr([false, false, false, true])}
          to="delete"
        >
          ՋՆՋՎԱԾՆԵՐ
        </NavLink>
        <button
          style={{ cursor: "pointer" }}
          className="enternew"
          onClick={() => window.open(`/${id}/add`, "_blank")}
        >
          {isSmall ? "+" : "ԱՎԵԼԱՑՆԵԼ ԳՈՒՅՔ"}
        </button>
      </nav>
      
        <Search
          district={district}
          district1={district1}
	      district2={district2}
          setDistrict={setDistrict}
          setDistrict1={setDistrict1}
	      setDistrict2={setDistrict2}
          asr={asr}
          setSearchedData={setSearchedData}
          id={id}
          navigate={navigate}
          data={data}
          allDeleted={allDeleted}
        />
     
      <div className="newinformation">
        <Outlet context={{ brokerinfo }} />
      </div>
    </div>
  );
}
